import { type Address } from '../api/data/Address'
import { type AddressInformation } from '../api/data/AddressInformation'
import { type CustomerInformation } from '../api/data/CustomerInformation'
import { type InsuranceInformation } from '../api/data/InsuranceInformation'
import { ReservationRequest } from '../api/data/ReservationRequest'
import { dateFormat } from '../helper/DateModel'

export interface CustomerInfoVM {
  firstName: string
  lastName: string
  email: string
  phone: string
  statusCheckMessage: boolean
  homeAddress1: string
  homeAddress2: string
  homeCity: string
  homeState: string
  homeZip: string
  licenseNumber: string
  licenseExpDate: string
  dateOfBirth: string
  licenseState: string
  insuranceCompany: string
  policyNumber: string
  insuranceExpDate: string
  insuranceImage: string
  insuranceCard: string
  vehicleMake: string
  vehicleModel: string
  vehicleYear: string
  VIN: string
  insuranceToggle: boolean
}

export function customerInformationMapper(customerInfoDto: CustomerInfoVM): CustomerInformation {
  const customerAddress: AddressInformation = {
    address1: customerInfoDto.homeAddress1,
    address2: customerInfoDto.homeAddress2,
    city: customerInfoDto.homeCity,
    region: customerInfoDto.homeState,
    postalCode: customerInfoDto.homeZip,
    country: 'US'
  }
  const insurance: InsuranceInformation = {
    insuranceCarrier: customerInfoDto.insuranceCompany,
    insurancePolicyNumber: customerInfoDto.policyNumber,
    insurancePolicyExpirationDate: new Date(customerInfoDto.insuranceExpDate),
    insuranceImage: customerInfoDto.insuranceImage,
    insuranceCard: customerInfoDto.insuranceCard,
    insuranceToggle: customerInfoDto.insuranceToggle
  }
  const customerInformation: CustomerInformation = {
    firstName: customerInfoDto.firstName,
    lastName: customerInfoDto.lastName,
    email: customerInfoDto.email,
    cellPhone: customerInfoDto.phone,
    driverLicenseNumber: customerInfoDto.licenseNumber,
    driverLicenseExpirationDate: new Date(customerInfoDto.licenseExpDate),
    dateOfBirth: new Date(customerInfoDto.dateOfBirth),
    driverLicenseState: customerInfoDto.licenseState,
    isTextAllowed: customerInfoDto.statusCheckMessage,
    vehicleMake: customerInfoDto.vehicleMake,
    vehicleModel: customerInfoDto.vehicleModel,
    vehicleYear: customerInfoDto.vehicleYear,
    VIN: customerInfoDto.VIN,
    customerAddress,
    insurance
  }

  return customerInformation
}

export function customerInfoVMMapper(reservation: ReservationRequest | undefined): CustomerInfoVM {
  const customerInfomationVM: CustomerInfoVM = {
    firstName: reservation?.customer?.firstName ?? '',
    lastName: reservation?.customer?.lastName ?? '',
    email: reservation?.customer?.email ?? '',
    phone: reservation?.customer?.cellPhone ?? '',
    statusCheckMessage: reservation?.customer?.isTextAllowed ?? false,
    homeAddress1: reservation?.customer?.customerAddress?.address1 ?? '',
    homeAddress2: reservation?.customer?.customerAddress?.address2 ?? '',
    homeCity: reservation?.customer?.customerAddress?.city ?? '',
    homeState: reservation?.customer?.customerAddress?.region ?? '',
    homeZip: reservation?.customer?.customerAddress?.postalCode ?? '',
    licenseNumber: reservation?.customer?.driverLicenseNumber ?? '',
    licenseExpDate: reservation?.customer?.driverLicenseExpirationDate ? dateFormat(reservation?.customer?.driverLicenseExpirationDate ?? new Date(), 'date_only') : '',
    dateOfBirth: reservation?.customer?.dateOfBirth ? dateFormat(reservation?.customer?.dateOfBirth ?? new Date(), 'date_only') : '',
    licenseState: reservation?.customer?.driverLicenseState ?? '',
    insuranceCompany: reservation?.customer?.insurance?.insuranceCarrier ?? '',
    insuranceToggle: reservation?.customer?.insurance?.insuranceToggle ?? false,
    policyNumber: reservation?.customer?.insurance?.insurancePolicyNumber ?? '',
    insuranceExpDate: reservation?.customer?.insurance?.insurancePolicyExpirationDate ? dateFormat(reservation?.customer?.insurance?.insurancePolicyExpirationDate ?? new Date(), 'date_only') : '',
    insuranceImage: reservation?.customer?.insurance?.insuranceImage ?? '',
    insuranceCard: reservation?.customer?.insurance?.insuranceCard ?? '',
    vehicleMake: reservation?.customer?.vehicleMake ?? '',
    vehicleModel: reservation?.customer?.vehicleModel ?? '',
    vehicleYear: reservation?.customer?.vehicleYear ?? '',
    VIN: reservation?.customer?.VIN ?? ''
  }
  return customerInfomationVM
}
